import { videoPack } from '@/mocks/homeData';
import SectionHead from './SectionHead';

export default function VideoWall() {
  return (
    <section id="video" className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-14">
      <SectionHead
        anchorId="video"
        kicker="Video · 封面驱动"
        title="视频切片墙"
        desc="现场实拍高清直出，封面即看点，点开就是一整套瓜。"
        href="#video"
        accent="accent"
      />
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
        {videoPack.map((v, i) => (
          <a
            key={i}
            href="#video"
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-background-300"
          >
            <div className="relative aspect-[3/4] overflow-hidden bg-background-100">
              <img
                src={v.img}
                alt={v.title}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-foreground-950/10"></div>
              <span className="absolute left-2 top-2 rounded-full bg-background-50/95 px-2 py-0.5 text-[11px] font-semibold text-foreground-900">
                {v.tag}
              </span>
              <span className="absolute bottom-2 right-2 rounded bg-foreground-950/80 px-1.5 py-0.5 text-[11px] text-background-100">
                {v.duration}
              </span>
              <span className="absolute left-1/2 top-1/2 flex h-11 w-11 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-background-50/95 text-primary-600 opacity-0 transition-all duration-300 group-hover:opacity-100">
                <i className="ri-play-fill text-xl pl-0.5"></i>
              </span>
            </div>
            <div className="flex flex-1 flex-col justify-between p-3">
              <h3 className="line-clamp-2 text-[13px] font-medium leading-snug text-foreground-900 group-hover:text-primary-600">
                {v.title}
              </h3>
              <span className="mt-2 inline-flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-eye-line"></i> {v.views}w 播放
              </span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}